import { render } from "./FilterBlocks.vue?vue&type=template&id=59e1445a"
import script from "./FilterBlocks.vue?vue&type=script&lang=js"
export * from "./FilterBlocks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__